import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Intake from "@/pages/Intake";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Testimonials from "@/pages/Testimonials";
import Achievements from "@/pages/Achievements";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import BookCall from "@/pages/BookCall";
import { ChatWidget } from "@/components/ChatWidget";
import { AuthCallback } from "@/components/AuthCallback";
import { ClientAuthProvider } from "@/context/ClientAuth";
import { WalkthruProvider } from "@/context/Walkthru";

function AppRouter() {
  const location = useLocation();
  // Read hash from useLocation (reactive), not window.location.hash. Process the
  // Google session_id FIRST, before any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/intake/:token" element={<Intake />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/book" element={<BookCall />} />
      </Routes>
      {!location.pathname.startsWith("/intake/") && !location.pathname.startsWith("/book") && <ChatWidget />}
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App font-body bg-white text-[#041C3E]">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ClientAuthProvider>
          <WalkthruProvider>
            <AppRouter />
          </WalkthruProvider>
        </ClientAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
